import { render, staticRenderFns } from "./CarrierRule.vue?vue&type=template&id=7a4c4bfa&scoped=true"
import script from "./CarrierRule.vue?vue&type=script&lang=js"
export * from "./CarrierRule.vue?vue&type=script&lang=js"
import style0 from "./CarrierRule.vue?vue&type=style&index=0&id=7a4c4bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4c4bfa",
  null
  
)

export default component.exports